import { Component } from '@angular/core';
import { AppState } from '../../../../../app/app.global';
import { App,LoadingController} from 'ionic-angular';
import { CopyrightDetail } from '../detail/detail';
import { HttpService } from '../../../../../providers/service/httpservice';
import { COPYRIGHTLIST,YEARLIST } from '../../../../../providers/config/serviceurl';
import { StorageService } from '../../../../../providers/service/storageservice';
@Component({
	selector: 'list',
  templateUrl: 'list.html'
})

export class CopyrightList {
	issue:string='';
	issues:any=[];
	artsitems:any=[];
	scienceitems:any=[];
	pageIndex = 1;
	pageNumber = 20;
  public loading;
  user:any;
  params:any=[];
  count:any;
  
	constructor(public global: AppState,public appCtrl: App,private httpService:HttpService,
		private loadCtrl:LoadingController) {
			this.count = StorageService.getObj('zzqcount');
			this.issue = StorageService.getObj('zzqissue');
			this.issues = StorageService.getObj('zzqissues');
			this.artsitems = StorageService.getObj('zzqartsitems');
			this.scienceitems = StorageService.getObj('zzqscienceitems');
			this.user = StorageService.getObj('currentUser');
			this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd,'queryTable':'KY_JSJRJZZQZL','queryKey':'zsqdrq','queryZgh':'ZZQR'};
			this.loadData(this.params);
	}
	
	getList(params){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		this.httpService.post(COPYRIGHTLIST,params).then(anyObj =>this.handleList(anyObj));
		this.loading.dismiss();//加载动画结束
	}

	
	//跳转详情
	openDetail(item){
		this.appCtrl.getRootNav().push(CopyrightDetail,item);
	}
	
	//下拉刷新
  doRefresh(refresher){
  	  setTimeout(() => {
    	 this.pageIndex = 1;
    	 this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd,'queryStr':this.issue};
    	 this.artsitems = [];
    	 this.scienceitems = [];
    	 this.getList(this.params);
    	 refresher.complete();
  	  }, 1000);
  }
  
  //上拉加载
	loadMore(refresher){
		setTimeout(() => {
				this.pageIndex++;
				this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd,'queryStr':this.issue};
				this.getList(this.params);
	      refresher.complete();
	  }, 500);
		
	}
	
	loadData(params){
		this.loading = this.loadCtrl.create({
			content: '加载中...',
		});
		this.httpService.post(YEARLIST,params).then(anyObj =>this.handleYearList(anyObj));
		this.httpService.post(COPYRIGHTLIST,params).then(anyObj =>this.handleList(anyObj));
		this.loading.dismiss();//加载动画结束
	}
	
	handleYearList(obj:any){
  	if(obj){
  		var year:any=[];
  		var length = obj.list.length;
  		if(this.issues == null){
  			this.issues = [];
  		}
  		for(var i=0;i<length;i++){
  			if(this.issues.indexOf(obj.list[i].NF)<0){
  				this.issues.push(obj.list[i].NF);
  			}
  			year.push(obj.list[i].NF);
  		}
  		//第一次加载数据的时候储存信息
  		if(this.pageIndex == 1){
  			this.issues = year;
  			StorageService.setObj("zzqissues",this.issues);
  		}
	}
  	
  }
	
	handleList(obj:any){
  	if(obj){
  		var vk:any=[];
  		var lk:any=[];
  		this.count = obj.count;
  		StorageService.setObj("zzqcount",this.count);
  		var length = obj.list.length;
  		if(this.artsitems == null){
  			this.artsitems = [];
  		}
  		if(this.scienceitems == null){
  			this.scienceitems = [];
  		}
  		for(var i=0;i<length;i++){
  			this.issue = obj.list[0].nf;
  			StorageService.setObj("zzqissue",this.issue);
  			if(obj.list[i].sjly!=null&&obj.list[i].sjly=="文科"){
  				this.artsitems.push(obj.list[i]);
  				vk.push(obj.list[i]);
  			}else if(obj.list[i].sjly!=null&&obj.list[i].sjly=="理科"){
  				this.scienceitems.push(obj.list[i]);
  				lk.push(obj.list[i]);
  			}
  		}
  		//第一次加载数据的时候储存信息
  		if(this.pageIndex == 1){
  			this.artsitems = vk;
  			this.scienceitems = lk;
  			StorageService.setObj("zzqartsitems",this.artsitems);
  			StorageService.setObj("zzqscienceitems",this.scienceitems);
  		}
	}
  }
	//查询年份
	issueSelect($event){
		this.artsitems = [];
    	this.scienceitems = [];
		this.pageIndex = 1;
		this.pageNumber = 20;
		this.params = {'pageNo':this.pageIndex,'pageSize':this.pageNumber,'hd':this.user.hd,'queryStr':$event};
		this.getList(this.params);
	}
}


// WEBPACK FOOTER //
// ./src/pages/application/research/copyright/list/list.ts